// Because the cms page lang differs from our LOCALE for the below pages
export default {
  'de-at': 'de_AT',
  'nl-be': 'nl_BE',
  'fr-be': 'fr_BE',
  'sv-se': 'sv',
};
